"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLevels = exports.UserLevel = void 0;
var UserLevel;
(function (UserLevel) {
    UserLevel[UserLevel["Employee"] = 0] = "Employee";
    UserLevel[UserLevel["GM"] = 3] = "GM";
    UserLevel[UserLevel["Owner"] = 5] = "Owner";
    UserLevel[UserLevel["Admin"] = 7] = "Admin";
})(UserLevel = exports.UserLevel || (exports.UserLevel = {}));
exports.UserLevels = Object.values(UserLevel).filter(function (l) { return typeof l === "number"; });
//# sourceMappingURL=user.js.map